import React from 'react';
import { motion } from "framer-motion";
import './Features.css';

function Features() {
  const featureList = [
    {
      title: "Intelligent Contract Review",
      text: "Upload your agreements and let our AI instantly detect crucial clauses, risks, and missing terms with expert-level precision.",
      icon: "⚖️"
    },
    {
      title: "AI-Powered Legal Drafting",
      text: "Create tailored legal documents in seconds using smart templates designed by experienced professionals.",
      icon: "🖋️"
    },
    {
      title: "Seamless Team Collaboration",
      text: "Work effortlessly with your colleagues — share, comment, and manage all your legal files securely in one workspace.",
      icon: "🤝"
    },
  ];

  // Container variants for staggered children animations
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
  };

  return (
    <section id="features" className="legal-features-section">
      <div className="legal-features-container">
        <motion.div 
          className="legal-features-header"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="legal-features-badge">Our Technology</span>
          <h2 className="legal-features-title">Powerful Features</h2>
        </motion.div>

        <motion.div 
          className="legal-features-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          {featureList.map((f, i) => (
            <motion.div
              className="legal-feature-card"
              key={i}
              variants={itemVariants}
              whileHover={{ y: -10, borderColor: "#dcb34e" }}
            >
              <div className="legal-feature-icon">{f.icon}</div>
              <h3 className="legal-feature-card-title">{f.title}</h3>
              <p className="legal-feature-card-text">{f.text}</p>
              <div className="legal-feature-line"></div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}

export default Features;